// assets/idioma-links.js
(function(){
  const HOSTS_ALLOWED = new Set(['ristretto.us','www.ristretto.us']);
  const PREFIX_EU = '/en-euro';
  const PREFIX_AU = '/en-au';
  const ATTRS = ['href','data-href'];

  // -------- Región actual --------
  function currentRegionPrefix() {
    const p = (location.pathname || '').toLowerCase();
    if (p === PREFIX_EU || p.startsWith(PREFIX_EU + '/')) return PREFIX_EU;
    if (p === PREFIX_AU || p.startsWith(PREFIX_AU + '/')) return PREFIX_AU;
    return ''; // US
  }

  function stripRegionPrefix(pathname) {
    const p = pathname || '/';
    if (p === PREFIX_EU) return '/';
    if (p.startsWith(PREFIX_EU + '/')) return p.slice(PREFIX_EU.length);
    if (p === PREFIX_AU) return '/';
    if (p.startsWith(PREFIX_AU + '/')) return p.slice(PREFIX_AU.length);
    return p;
  }

  function toAbsoluteUrl(value) {
    try {
      if (value.startsWith('//')) {
        return new URL(location.protocol + value);
      }
      return new URL(value, location.origin);
    } catch {
      return null;
    }
  }

  function rewriteUrlKeepingPath(raw, targetPrefix) {
    const u = toAbsoluteUrl(raw);
    if (!u) return raw;

    const sameHost = HOSTS_ALLOWED.has(u.hostname);
    const isRelative = !/^https?:/i.test(raw) && !raw.startsWith('//');
    if (!sameHost && !isRelative) return raw;
    if (isRelative && !HOSTS_ALLOWED.has(location.hostname)) return raw;

    if (!targetPrefix) {
      return u.toString(); // US → no modificar
    }

    if (u.pathname === targetPrefix || u.pathname.startsWith(targetPrefix + '/')) {
      return u.toString();
    }

    const base = stripRegionPrefix(u.pathname);
    const basePath = base.startsWith('/') ? base : '/' + base;
    u.pathname = targetPrefix + basePath;

    if (isRelative) {
      return u.pathname + (u.search || '') + (u.hash || '');
    }

    u.hostname = 'ristretto.us';
    u.protocol = location.protocol;

    return u.toString();
  }

  function processElement(el, targetPrefix) {
    // Procesar atributos href / data-href
    for (const attr of ATTRS) {
      if (!el.hasAttribute(attr)) continue;
      const val = el.getAttribute(attr);
      if (!val) continue;
      const newVal = rewriteUrlKeepingPath(val, targetPrefix);
      if (newVal !== val) el.setAttribute(attr, newVal);
    }

    // Procesar onclick inline (window.location.href='...')
    const onclick = el.getAttribute('onclick');
    if (onclick && /window\.location\.href\s*=\s*['"]([^'"]+)['"]/.test(onclick)) {
      const urlMatch = onclick.match(/window\.location\.href\s*=\s*['"]([^'"]+)['"]/);
      if (urlMatch) {
        const originalUrl = urlMatch[1];
        const newUrl = rewriteUrlKeepingPath(originalUrl, targetPrefix);
        if (newUrl !== originalUrl) {
          const updated = onclick.replace(originalUrl, newUrl);
          el.setAttribute('onclick', updated);
        }
      }
    }
  }

  function scan(root, targetPrefix) {
    root.querySelectorAll('a[href],button[href],a[data-href],button[data-href],button[onclick]').forEach(el=>{
      processElement(el, targetPrefix);
    });
  }

  function init() {
    const targetPrefix = currentRegionPrefix();
    scan(document, targetPrefix);

    const mo = new MutationObserver((mutations)=>{
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('a[href],button[href],a[data-href],button[data-href],button[onclick]')) {
            processElement(node, targetPrefix);
          }
          scan(node, targetPrefix);
        }
      }
    });
    mo.observe(document.documentElement || document.body, { childList:true, subtree:true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
